import { MprcCard } from "components";
import * as React from "react";

interface IProps {
    children?: React.ReactNode;
    minWitdh?: string;
}

export const MprcCardFilterBox: React.FC<IProps> = ({ children, minWitdh }) => {

    return (
        <MprcCard
            paperColor={["paper", "dark"]}
            borderRadius="md"
            sx={
                (theme) => (
                    {
                        margin: 0,
                        padding: theme.spacing(1),
                        minWidth: minWitdh ?? "inherit",
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0
                    })
            }
        >
            {children}
        </MprcCard>
    );
};
